//global defaults for i18n/<site>.js

export default {

  navHome: 'Accueil',
  navContact: 'Contact',
  navHelp: 'Aide',
  navReplays: 'Replays',
  navLegal: 'Conditions générales',
  navConfidentiality: 'Données personnelles',
  navMyAccount: 'Mon compte',
  navCookies: 'Cookies',
  navAccounts: 'Professionnels',
  navEvents: 'Evénements',
  navThemes: 'Thèmes',
  navModerator: 'Modération',
  navExports: 'Exports',
  navAbout: 'A propos de Norgine',
  navFaq: 'Admin Aide',
  adminCms: 'Admin CMS',
  navNews: 'Admin News',
  navUtms: 'Admin UTMs',
  navLogs: 'Admin Logs',
  navEmails: 'Admin Emails',
  navVideos : 'Vidéos',
  adminDocumentation: 'Admin Documentation',

  // UI
  loading: 'Chargement...',

  // Home
  homeTitle1: 'Des rendez-vous réguliers & interactifs avec les experts de votre spécialité',
  // homeTitle: 'CANALHEMATO',
  // homeSubtitle1: 'WEBCONFÉRENCES',
  // homeSubtitle2: 'WEBCASTS',
  // homeSubtitle3: 'PODCASTS',
  homeRegisterBtn: "Je m'inscris",
  // homeLoginBtn: 'JE ME CONNECTE',
  // homeBannerTitle: false,
  // homeBannerText1: 'Des sessions courtes à des dates et des horaires différents pour s'adapter à votre emploi du temps',
  // homeBannerText2: 'La possibilité de poser toutes vos questions en direct aux experts',
  //
  // homeNoAvailableEvent: "Nous sommes désolés mais il n'y a actuellement pas d'émission disponible",
  //
  // // Header
  headerTitle: 'VOTRE PROCHAINE WEBCONFERENCE :',
  // headerSubtitle1: 'A déjà débuté !',
  // headerSubtitle2: 'COMMENCE DANS :',
  // headerBtn1: 'Accéder au live',
  // headerBtn2: 'Modifier la session',
  //
  mainTitle: "L’ACTUALITÉ SCIENTIFIQUE DES MICROBIOTES\n[b]EN LIGNE[/b], [b]EN DIRECT ET INTERACTIVE[/b]",
  selectAnEvent: 'Choisissez une ou plusieurs sessions, puis cliquez sur [b]Etape suivante[/b]',
  selectAnEventSubmit: 'Etape suivante >',
  inviteToEventSubmit: 'Inviter un participant >',
  //
  // // Footer
  // footerLegal: 'Conditions Générales',
  // footerConfidentiality: 'Données personnelles',
  // footerVersion: false,
  //
  // // Banner
  bannerTitle: "BESOIN D'AIDE POUR UTILISER L'OUTIL DE WEBCONFERENCE ?",
  bannerHelp: "Voir notre rubrique d'aide",
  bannerContact: 'Nous contacter',
  //
  // // Card
  // cardPresentedBy: 'Animé par',
  // cardWarning:
  //   "Attention ! Si vous n'avez pas assisté à la session à laquelle vous étiez inscrit(e) (pas de connexion le jour J) vous pourrez vous inscrire à une nouvelle session. En revanche si vous avez assisté à une session ou que vous vous êtes connecté(e) le jour J le calendrier sera fermé et vous ne pourrez plus vous incrire à une session ultérieure.",
  // cardErrorBtn: 'Terminer',
  // cardGoBackBtn: 'Retour',
  // cardLiveBtn: 'Accéder au live',
  // cardSubtitle1: 'La conférence a déjà débuté !',
  // cardUpdateBtn: 'Modifier la date',
  //
  loginFormTitle: "J'ai déjà un compte",
  // // Subscription
  //
  // // subscriptionFormSelfTitle: "",
  // subscriptionSelfTitle: 'Inscription aux conférences',
  // subscriptionSelfText: 'Pour confirmer votre inscription, veuillez cliquer sur le bouton suivant',
  // subscriptionSelfButton: "S'inscrire",
  // subscriptionSelfSuccessTitle: 'Votre inscription a bien été\n prise en compte !',
  // subscriptionSelfSuccessText: false,
  // subscriptionSelfErrorTitle: 'Vous ne pouvez pas modifier la date de votre inscription',
  // subscriptionSelfErrorText:
  //   'Vous avez déjà assisté à une webconference, ou la date de la webconference à laquelle vous etiez inscrit(e) est dépassée',
  // subscriptionFormSelfButton: "S'inscrire",
  // subscriptionFormVisitorTitle: false,
  // subscrionFormInstructions: false,
  // subscriptionFormFooter: false,
  subscriptionModifyDateText: 'Souhaitez-vous valider la modification de votre inscription ?',
  //
  // subscriptionForTitle: 'Inviter un participant',
  // subscriptionForText: "Veuillez saisir l'email du participant à inviter",
  // subscriptionForSuccessTitle: 'Invitation enregistrée',
  // subscriptionForSuccessText: false,
  //
  subscriptionCurrentlySubscribedSingle: 'Vous êtes inscrit(e) à la session suivante :',
  subscriptionCurrentlySubscribedPlural: 'Vous êtes inscrit(e) aux sessions suivantes :',
  subscriptionNewSubscribedSingle: 'Vous avez choisi la session suivante :',
  subscriptionNewSubscribedPlural: 'Vous avez choisi les sessions suivantes :',
  //
  // subscriptionSuccessTitle: 'Votre inscription a bien été\n prise en compte',
  //
  // subscriptionSuccessText: false,
  //
  // // Registration

  registrationFormTitle: "Je n'ai pas de compte",
  // registrationFormInstructions: false,
  // registrationFormFooter: false,
  registrationSuccessTitle: 'Votre inscription\na bien été prise en compte.',
  registrationModifiedTitle: 'Votre inscription\n a bien été modifiée !',
  registrationByStaffSuccessTitle: "Votre inscription\na bien été prise en compte!",
  registrationByStaffModifiedTitle: "Votre inscription\na bien été prise en compte!",

  registrationLogSuccess: 'Vous pouvez dès à présent\nvous connecter pour accéder à votre espace personnel',
  registrationSuccessLogX1:
    "Vous recevrez un email de confirmation ou une demande de renseignements d'ici 48 heures",
  registrationSuccessLogX2:
    "Vous recevrez un email de confirmation ou une demande de renseignements d'ici 48 heures",
  registrationSuccessLogX3:
    "Vous recevrez un email de confirmation ou une demande de renseignements d'ici 48 heures",
  registrationSuccessLogX4:
    "Vous recevrez un email de confirmation ou une demande de renseignements d'ici 48 heures",
    // registrationLogStudents: false,
  registrationLogMdNoRpps: false,

  // registrationSuccessText: false,
  // registrationJobWarning:
  //   "L'inscription sur canalhemato.fr est réservée aux personnels de santé.\n Vous devez posséder un numéro RPPS ou ADELI pour vous inscrire.",
  // registrationPreLegend:
  //   "En cliquant sur le bouton ci-dessous, « je certifie sur l'honneur être la personne dont les coordonnées sont indiquées dans le présent formulaire. Je reconnais que l'usurpation de l'identité d'un tiers constitue un délit pouvant donner lieu à des poursuites ainsi qu'à une sanction pénales »",
  //
  registrationLogLegend1: false,
  // registrationLogLegend1:
  //   "Sauf mention contraire, tous les champs sont obligatoires pour valider votre inscription.\n\nNB : Votre numéro de téléphone et votre adresse email serviront exclusivement à vous envoyer par sms et par email un rappel de la date de la webconférence à laquelle vous êtes inscrit(e)\n\nTout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.\n\n",
  //
  // registrationLogLegend2: '',
  registrationLogLegend2: false,
  //
  //
  // // Contact
  contactFormTitle: 'Contactez-nous',
  //
  // // Help
  helpTitle: 'Aide',
  // helpContactUs: 'Nous contacter',
  // helpContactUsLabel: 'Vous avez des questions ?',
  //
  // // Legal
  // legalPageTitle: "Conditions Générales d'utilisation",
  //
  // // Confidentiality
  // confidentialityPageTitle: 'Données personnelles',
  //
  mediasTitle: "Médias",
  // registrationLogStudents: '',
  // Speedtest@
  speedTestButtonLabel: 'Testez votre connexion internet',
  speedTestButtonStart: 'Lancer le test',
  speedTestButtonRestart: 'ReLancer le test',
  //
  // // Live
  liveInfo:
    "Tout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.",

    feedbackSuccess: "Votre évaluation a bien été enregistrée !",
feedbackMustAnswerAll:
  "Merci de répondre à toutes les questions afin d'envoyer le formulaire...",

quizSend: "Envoyer",
quizInstructionsPlural:
  "Veuillez choisir de 1 à {max} réponse(s) parmi les {size} possibles.",
quizInstructionsSingle:
  "Veuillez choisir 1 réponse parmi les {size} possibles.",
quizSuccess: "Votre réponse a bien été enregistrée !",
quizMustChose: "Veuillez faire votre choix afin d'envoyer votre réponse",
quizQuestionActivate: "Activer",
quizQuestionIsActive: "Activée",
quizResults: "Résultats :",
formFieldsRequiredLegend: "* Champs obligatoires",
loginForgotPassword: 'Mot de passe oublié ?',
loginForgotPasswordText: "Saisissez votre identifiant afin de recevoir un mail qui vous\npermettra de changer votre mot de passe",

subscriptionPendingSuccessTitle: "Votre inscription est en cours de validation.\nVous recevrez un email d'ici 48 heures. Vous pourrez alors vous inscrire aux évènements de votre choix. Vérifiez vos spams.",
subscriptionVerifiedSuccessTitle: 'Votre inscription a bien été prise en compte.\nVous pouvez maintenant vous connecter.',
subscriptionHasRpps: 'J’ai un numéro RPPS',
subscriptionHasAdeli: 'J’ai un numéro ADELI',
subscriptionHasNoRpps: 'Je n’ai pas de numéro RPPS/ADELI',
subscriptionHasNoId: "Je n'ai pas de numéro RPPS/ADELI",
subscriptionFormNotice:"",
subscriptionFormInstructions: 'Indiquez vos noms/prénoms tels que sur votre carte professionnelle',


homeAvailableEvents:'Nos webconférences',
homeYourEvents:'Mon agenda',
homeReplays:'Nos replays',
subscribeAction:"Je m'inscris",

eventDescription: "Description",
eventProgram: "Programme",
eventDates: "Date(s)",
eventDuration: "Durée : ",
eventAnimatedBy: "Animé(e) par : ",

liveAction: "Regarder",
liveEventIsStarted: "Live !",
liveYourEventStartsIn: "Votre webconférence débute dans :",
liveClickToRefreshPage: "Cliquez pour recharger la page et accéder au live",
liveClickToRefreshPageAndGotoLive: "Cliquez pour recharger la page et accéder au live",
ClickToRefreshPage: "Cliquez pour recharger la page",

subscriptionShowProgram: 'Programme',
subscriptionAlreadyExists: "Déjà inscrit(e)",
subscriptionAlreadyExistsLong: "Déjà inscrit(e) à la date sélectionnée",
subscriptionMustChoseDate: "Veuillez choisir une date ci-dessus",
subscriptionTitle: 'Inscription',
subscriptionMemberSuccessTitle: 'Votre inscription a bien été\n prise en compte',

loginAction: "Connexion",
loginFieldEmail: 'Email',
loginFieldPassword: 'Mot de passe',
loginFormSubmit: "Je me connecte",

helpBannerTitle: "Besoin d'aide pour utiliser l'outil ?",
helpBannerGotoHelp: 'Rubrique aide',
helpBannerGotoContact: 'Nous contacter',

replayNext: 'Replay suivant >',
replayPrevious: '< Replay précédent',
replayAction: "Regarder",
replaysTitle:"Replays",
replayTimecodesToggler: 'Chapitres',
replayTimecodeTitle: "Chapitres",
replayCopyrightWarning: "Tout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.",

liveMustLoginFirst: "Merci de vous connecter, ou de créer un compte pour accéder à ce contenu",
liveCopyrightWarning: "Tout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.",
liveHelpTitle: "Comment bien visualiser votre live ?",
liveHelpMore: "Voir les autres conditions de visualisation",
liveHelpDetails: "* Lore ipsum lorem ipsum lorem ipsum.",
liveLegalFile: "Mentions légales",
eventStateLive: 'Live',
eventStateOnline: 'En ligne',
eventStatePending: 'À venir',
eventStateFinished: 'Terminé',
eventStateReplay: 'Replay',

videosTitle:"Vidéos",
videosTabTitle_replays:"Nos replays",
videosTabTitle_other:"Nos autres vidéos",
othervideos:"Autres vidéos",
home:"Accueil",

documentationTitle:"Documentation",

homeBannerTitle:"Des évènements en direct et interactifs",
homeBannerSubTitle:"Mis en place par votre interlocuteur Biocodex",

accountFormTitle: 'Mon compte',
accountDeleteButton: 'Supprimer mon compte',
accountDeleteTitle: "Suppression de votre compte",
accountDeleteText: "Attention !\nLa suppression de votre compte est définitive !!!",
accountDeleteBtConfirm: "Je confirme vouloir supprimer mon compte",
accountCurrentPassword: "Mot de passe actuel",
accountDeleteMustSpecifyPassword: "Veuillez saisir votre mot de passe.",
accountChangePassBt: 'Modifier mon mot de passe',
accountEmail: 'Email',
accountFirstname: 'Prénom',
accountLastname: 'Nom',
accountJob: 'Profession',
accountYourAccount: 'Votre compte',
accountPresent: 'Présent(e)',
accountData: 'Identification',
accountAddress: 'Coordonnées',
accountAccessRestricted: 'Accès Administrateur',
accountChangeOptinsBt: "Préférences de notification",
formCancel: "Annuler",

newsSoonAvailable: 'Bientôt disponible !',
newsNew: 'Nouveau',
newsShowMore: 'Voir plus',
newsClose: 'Fermer',
newsReplay: 'Replay',
newsEvent: 'Webconference',
newsFlash: 'Information',

rgpdPopin:
"Nous utilisons des cookies nécessaires au fonctionnement du site internet et permettant d’améliorer votre navigation. Ces cookies ne peuvent pas être désactivés de nos systèmes et sont établis en tant que réponse à des actions que vous avez effectuées. Vous pouvez configurer votre navigateur afin de bloquer ces cookies mais votre navigation et votre expérience sur ce site peuvent être dégradées.\nPour plus d’informations, consultez notre [local url=/cookies]Politique de gestion des cookies[/local] et [local url=/confidentiality]nos engagements en matière de Confidentialité[/local].",

rgpdAccept: "Fermer",


footerLegalNotice:'© Tous droits réservés.',

subscriptionPopupText:"[...]",

event_wrong_user_univers:"Votre inscription à cet événement ne peut être prise en compte.\nNous vous invitons à choisir un autre événement en cliquant sur le bouton Accueil",
event_wrong_user_job:"Votre inscription à cet événement ne peut être prise en compte.\nNous vous invitons à choisir un autre événement en cliquant sur le bouton Accueil",

};



// WEBPACK FOOTER //
// ./src/components/UI/messages_fr.js